





import { Component, Vue } from 'vue-property-decorator';

import Checkbox from '@/shared/components/checkbox.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    Checkbox,
    ExpansionPanel,
  },
})
export default class PartialCheckbox extends Vue {
  private checkboxState: boolean = true;
}
